/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
//import { loadingProfileConfig } from '../../config/loading.config';
import { headerProfileConfig } from '../../config/header.config';
import { errorProfileConfig } from '../../config/error.config';
import { notificationProfileConfig } from '../../config/notifications.config';
import { editProfileConfig } from '../../config/editProfile.config';

export interface IStaticPagePluginMethods extends IPluginMethodMap {
  getStaticPageSync(args?: any): any;
}

export class StaticPagePlugin implements IAgentPlugin {
  readonly methods: IStaticPagePluginMethods;

  constructor() {
    this.methods = {
      getStaticPageSync: this.getStaticPageSync.bind(this),
    };
  }

  getStaticPageSync(args?: any) {
    return {
      header: headerProfileConfig,
      //loading:loadingProfileConfig,
      error: errorProfileConfig,
      notifications: notificationProfileConfig,
      editProfile: editProfileConfig,
    };
  }
}
